import React, { useState, useEffect } from 'react';
import { useTickContext } from "../../contexts/TickContext";
import {useStateUpdatePermission} from "../../contexts/StateUpdateContext";
import {useQuoteContext} from "../../contexts/QuoteContext";

const LastTradedPriceDisplay = React.memo(({  priceColor, contextName }) => {
    const [lastPrice, setLastPrice] = useState('0.0');
    const { canUpdateState } = useStateUpdatePermission(); // Access the permission state
    const tickContext = useTickContext();
    const quoteContext = useQuoteContext();

    const contextData = (() => {
        switch (contextName) {
            case 'TickContext':
                return tickContext;
            case 'QuoteContext':
                return quoteContext;
            default:
                throw new Error(`Unknown context: ${contextName}`);
        }
    })();
    const tick = contextData.tick;

    // Fetch the last traded price and update its color
    useEffect(() => {
        if (canUpdateState && tick.lastTradedPrice !== undefined) {
            /*console.log('tick.lastTradedPrice:', tick.lastTradedPrice);*/
            setLastPrice(tick.lastTradedPrice);
        }
    }, [tick.lastTradedPrice]);

    return (
        <div className="last-traded-price-st" style={{ color: priceColor }}>
            {lastPrice}
        </div>
    );
});

export default LastTradedPriceDisplay;
